import dayjs from 'dayjs';
import * as Yup from 'yup';

const parseDateString = (value: any, originalValue: any) => {
  const parsedDate = dayjs(originalValue).isValid()
    ? value
    : dayjs(originalValue).format('MMMM DD, YYYY');

  return parsedDate;
};

export const getValidationSchema = (
  isDirectFeedback = false,
  isSpeechCraftMFE = false,
) =>
  Yup.object({
    clubId: isSpeechCraftMFE
      ? Yup.number()
      : Yup.object().nullable()
      .shape({
          name: Yup.string().required('Name is required'),
          id: Yup.number().required('id is required'),
      }).required('Club is required'),
    clubMembers: isDirectFeedback
      ? Yup.object().nullable()
      .shape({
          name: Yup.string(),
          id: Yup.number(),
      }).required('Evaluator is required')
      : Yup.array()
          .min(1, 'At least 1 member is required')
          .required('Evaluator is required'),
    speechTitle: isDirectFeedback
      ? Yup.string()
      : Yup.string().required('Speech Title is required'),
    speechDate: Yup.date()
      .transform(parseDateString)
      .typeError('Invalid date format. (MMMM DD, YYYY)')
      .nullable()
      .required('Date is required'),
    request: Yup.string(),
  });
